import {StyleSheet} from 'react-native';
import Typography from '@shared/constants/Typography';

export const createStatusIndicatorStyles = (theme: any) =>
  StyleSheet.create({
    // ─── Shared badge container ───────────────────────────────────────────────
    badgeContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: Typography.radius.radius8,
      paddingVertical: Typography.padding.padding6,
      paddingHorizontal: Typography.padding.padding8,
      //borderWidth: Typography.borderWidth.borderWidth1,
      gap: Typography.gap.gap4,
    },
    badgeText: {
      fontSize: Typography.fontSize.fontSize10,
      fontWeight: Typography.fontWeight.semiBold,
      fontFamily: Typography.fontFamily.inter,
      color: theme.defaultStatusColor,
    },

    // ─── Parts Assigned states ────────────────────────────────────────────────
    partsAssigned: {
      backgroundColor: theme.partsAssignedEnabledBG,
      borderColor: theme.partsAssigneEnabledBorder,
    },
    partsUnAssigned: {
      backgroundColor: theme.partsAssignedDisabledBG,
      borderColor: theme.partsAssignedDisabledBorder,
    },

    // ─── Priority levels ──────────────────────────────────────────────────────
    priorityUrgent: {
      backgroundColor: theme.highPriorityBGColor,
      borderColor: theme.highPriorityBorderColor,
    },
    priorityHigh: {
      backgroundColor: theme.mediumPriorityBGColor,
      borderColor: theme.mediumPriorityBorderColor,
    },
    priorityMedium: {
      backgroundColor: theme.lowPriorityBGColor,
      borderColor: theme.lowPriorityBorderColor,
    },
    priorityLow: {
      backgroundColor: theme.leastPriorityBGColor,
      borderColor: theme.leastPriorityBorderColor,
    },
    priorityNA: {
      borderColor: theme.partsAssignedDisabledBorder,
    },

    // ─── No style (stylesRequired=false) ──────────────────────────────────────
    noStyle: {
      borderWidth: 0,
      backgroundColor: 'transparent',
    },
  });